// extracted by mini-css-extract-plugin
export default {"root":"qLhPO_","createPostButton":"ze1XxU"};